import { DatepickerComponent } from 'mbs-ui-kit';

export function clearDatepickers(pickers: DatepickerComponent[], force = true): void {
  const clearIfNeeded = (picker: DatepickerComponent) => {
    if (!picker) return;
    if (force || picker.date == null) {
      picker.date = '';
    }
  };

  pickers.forEach((picker) => {
    clearIfNeeded(picker);
  });
}
